/**
 * Product Thumbnails Component JavaScript
 * This script handles the functionality of the custom product thumbnail component
 */

// Pre-cache all product images for immediate display
function preloadProductImages() {
  console.log('Preloading all product images...');
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  
  // Create hidden container for preloaded images
  let preloadContainer = document.getElementById('product-image-preload');
  if (!preloadContainer) {
    preloadContainer = document.createElement('div');
    preloadContainer.id = 'product-image-preload';
    preloadContainer.style.position = 'fixed';
    preloadContainer.style.left = '-9999px';
    preloadContainer.style.top = '-9999px';
    preloadContainer.style.width = '1px';
    preloadContainer.style.height = '1px';
    preloadContainer.style.overflow = 'hidden';
    document.body.appendChild(preloadContainer);
  }
  
  // Store loaded image URLs to avoid duplicates
  const loadedImages = new Set();
  
  // Preload each thumbnail's full-size image
  thumbnails.forEach(function(thumb) {
    // Extract image URL from data attributes or construct from img src
    const thumbImg = thumb.querySelector('img');
    if (!thumbImg) return;
    
    // Try to get full-size URL from data attributes
    let fullSizeUrl = thumb.getAttribute('data-full-url') || thumb.getAttribute('data-image-url');
    
    // If not found in data attributes, construct from img src
    if (!fullSizeUrl && thumbImg) {
      const thumbSrc = thumbImg.getAttribute('data-src') || thumbImg.getAttribute('src');
      if (thumbSrc) {
        fullSizeUrl = thumbSrc.replace(/_60x60/g, '').replace(/_100x100/g, '');
      }
    }
    
    // Skip if no valid URL or already loaded
    if (!fullSizeUrl || loadedImages.has(fullSizeUrl)) return;
    
    // Mark as loaded
    loadedImages.add(fullSizeUrl);
    
    // Create a new image and add to preload container
    const preloadImg = new Image();
    preloadImg.src = fullSizeUrl;
    preloadImg.setAttribute('data-preloaded', 'true');
    preloadContainer.appendChild(preloadImg);
    
    // Store URL on thumbnail for quick reference
    thumb.setAttribute('data-image-url', fullSizeUrl);
    
    console.log('Preloading:', fullSizeUrl);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Preload images first for faster initial clicks
  preloadProductImages();
  
  // Then initialize thumbnails
  initProductThumbnails();
  
  // Also initialize again after a delay in case of dynamic content loading
  setTimeout(function() {
    preloadProductImages();
    initProductThumbnails();
  }, 1000);
});

// Expose the init function globally so it can be called after ajax content loads
window.initProductThumbnails = initProductThumbnails;

function initProductThumbnails() {
  // Initialize all thumbnail containers
  var containers = document.querySelectorAll('.product-thumbnails-container');
  
  if (!containers.length) {
    return;
  }
  
  containers.forEach(function(container) {
    var thumbnailWrapper = container.querySelector('.thumbnail-wrapper');
    var thumbnails = container.querySelectorAll('.product-thumbnail');
    var prevButton = container.querySelector('.thumbnails-prev');
    var nextButton = container.querySelector('.thumbnails-next');
    var mainImageSelector = container.getAttribute('data-main-image-selector') || '.js_prod_main';
    var mainImages = document.querySelectorAll(mainImageSelector + ' .product-image-wrapper img, ' + mainImageSelector + ' img');
    var thumbnailsContainer = container.querySelector('.product-thumbnails');
    var isVertical = container.classList.contains('product-thumbnails--vertical');
    var visibleThumbnails = isVertical ? 5 : 5; // Number of visible thumbnails
    var currentIndex = 0;
    var thumbnailSize = 65; // Size of each thumbnail in pixels (including gap)
    
    // Touch swipe variables
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;
    var minSwipeDistance = 30; // Minimum distance to register as a swipe
    
    // Calculate total thumbnails
    var totalThumbnails = thumbnails.length;
    
    // Only show navigation if we have more than the visible amount
    if (totalThumbnails <= visibleThumbnails) {
      if (prevButton) prevButton.style.display = 'none';
      if (nextButton) nextButton.style.display = 'none';
    } else {
      if (prevButton) {
        prevButton.style.display = 'flex';
        prevButton.style.opacity = '0.5'; // Start with prev disabled
        prevButton.disabled = true;
      }
      if (nextButton) {
        nextButton.style.display = 'flex';
        nextButton.style.opacity = totalThumbnails > visibleThumbnails ? '1' : '0.5';
        nextButton.disabled = totalThumbnails <= visibleThumbnails;
      }
    }
    
    // Set first thumbnail as active if none are already active
    var activeThumb = container.querySelector('.product-thumbnail.active');
    if (!activeThumb && thumbnails.length > 0) {
      thumbnails[0].classList.add('active');
    }
    
    // Remove any existing event listeners (to prevent duplicates)
    thumbnails.forEach(function(thumbnail) {
      var newThumbnail = thumbnail.cloneNode(true);
      thumbnail.parentNode.replaceChild(newThumbnail, thumbnail);
    });
    
    // Get fresh references
    thumbnails = container.querySelectorAll('.product-thumbnail');
    
    // Function to scroll to a specific thumbnail
    function scrollToThumbnail(index) {
      if (index < 0) index = 0;
      if (index >= thumbnails.length) index = thumbnails.length - 1;
      
      currentIndex = index;
      
      // Calculate scroll position
      var scrollPos = index * thumbnailSize;
      
      // Apply scroll with smooth animation
      if (thumbnailWrapper) {
        if (isVertical) {
          thumbnailWrapper.style.transform = 'translateY(-' + scrollPos + 'px)';
        } else {
          thumbnailWrapper.style.transform = 'translateX(-' + scrollPos + 'px)';
        }
        thumbnailWrapper.style.transition = 'transform 0.3s ease';
      } else {
        // Fallback for older template
        if (isVertical) {
          thumbnailsContainer.scrollTo({
            top: scrollPos,
            behavior: 'smooth'
          });
        } else {
          thumbnailsContainer.scrollTo({
            left: scrollPos,
            behavior: 'smooth'
          });
        }
      }
      
      // Update button state
      updateButtonState();
    }
    
    // Update navigation button state (disabled at ends)
    function updateButtonState() {
      if (prevButton && nextButton) {
        prevButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex >= thumbnails.length - visibleThumbnails;
        
        prevButton.style.opacity = prevButton.disabled ? '0.5' : '1';
        nextButton.style.opacity = nextButton.disabled ? '0.5' : '1';
      }
    }
    
    // Function to navigate thumbnails
    function navigateThumbnails(direction) {
      var newIndex = currentIndex + direction;
      
      // Ensure we don't go out of bounds
      if (newIndex < 0) newIndex = 0;
      if (newIndex > thumbnails.length - visibleThumbnails) {
        newIndex = thumbnails.length - visibleThumbnails;
        if (newIndex < 0) newIndex = 0; // In case we have fewer than visibleThumbnails
      }
      
      scrollToThumbnail(newIndex);
    }
    
    // Set up the thumbnail wrapper for proper display
    if (thumbnailWrapper) {
      thumbnailWrapper.style.transition = 'transform 0.3s ease';
      if (isVertical) {
        thumbnailWrapper.style.height = (thumbnails.length * thumbnailSize) + 'px';
      } else {
        thumbnailWrapper.style.width = (thumbnails.length * thumbnailSize) + 'px';
      }
    }
    
    // Handle thumbnail click
    thumbnails.forEach(function(thumbnail, idx) {
      thumbnail.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent default click behavior
        
        // Get index and image URL from thumbnail
        var index = idx; // Use actual array index instead of data attribute
        var imageUrl = this.getAttribute('data-image-url');
        
        // If URL wasn't set by preloader, extract it now
        if (!imageUrl) {
          const thumbImg = this.querySelector('img');
          if (thumbImg) {
            const thumbSrc = thumbImg.getAttribute('data-src') || thumbImg.getAttribute('src');
            if (thumbSrc) {
              imageUrl = thumbSrc.replace(/_60x60/g, '').replace(/_100x100/g, '');
              this.setAttribute('data-image-url', imageUrl); // Save for future clicks
            }
          }
        }
        
        // Always update main image regardless of whether thumbnail is already active
        updateMainImage(this, index, imageUrl);
        
        // Make sure the clicked thumbnail is visible in the carousel
        var visibleStart = currentIndex;
        var visibleEnd = currentIndex + visibleThumbnails - 1;
        
        // If clicked thumbnail is outside visible range, scroll to show it
        if (idx < visibleStart) {
          scrollToThumbnail(idx);
        } else if (idx > visibleEnd) {
          scrollToThumbnail(idx - visibleThumbnails + 1);
        }
      });
    });
    
    // Fast image update by manipulating display of image wrappers
    function fastImageUpdate(targetUrl) {
      const wrappers = document.querySelectorAll('.product-image-wrapper');
      if (wrappers.length === 0) return false;
      
      // Hide all wrappers first
      wrappers.forEach(wrapper => wrapper.style.display = 'none');
      
      // Find matching wrapper with the target image
      let matchFound = false;
      wrappers.forEach(wrapper => {
        const img = wrapper.querySelector('img');
        if (!img) return;
        
        const imgSrc = img.getAttribute('src') || img.getAttribute('data-src');
        if (imgSrc && (imgSrc === targetUrl || imgSrc.includes(targetUrl) || targetUrl.includes(imgSrc))) {
          // Show this wrapper
          wrapper.style.display = 'flex';
          matchFound = true;
          console.log('Fast image update: Found matching wrapper');
        }
      });
      
      return matchFound;
    }
    
    // Function to update main image
    function updateMainImage(thumbnailElement, index, imageUrl) {
      // Update active state
      thumbnails.forEach(function(t) { t.classList.remove('active'); });
      thumbnailElement.classList.add('active');
      
      console.log('Updating main image to:', imageUrl, 'Index:', index);
      
      // First try the fast update method
      if (fastImageUpdate(imageUrl)) {
        console.log('Fast image update successful');
        return; // Exit if successful
      }
      
      // Get fresh references to main images (in case DOM has changed)
      var currentMainImages = document.querySelectorAll(mainImageSelector + ' .product-image-wrapper img, ' + mainImageSelector + ' img');
      
      // Function to normalize image size and appearance
      function normalizeImageSizing(img) {
        // Record original dimensions for reference
        var naturalWidth = img.naturalWidth;
        var naturalHeight = img.naturalHeight;
        var aspectRatio = naturalWidth / naturalHeight;
        
        // Force consistent dimensions on the image
        img.style.maxHeight = '400px';
        img.style.maxWidth = '100%';
        img.style.width = 'auto';
        img.style.height = 'auto';
        img.style.objectFit = 'contain';
        img.style.margin = '0 auto';
        img.style.display = 'block';
        
        // Force the container to have consistent dimensions
        var container = img.closest('.product-image-wrapper, .js-zoom-img, .zoom-image, .js_prod_main, .product-image-container');
        if (container) {
          container.style.height = '400px';
          container.style.minHeight = '400px';
          container.style.maxHeight = '400px';
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.justifyContent = 'center';
          container.style.position = 'relative';
          container.style.overflow = 'hidden';
        }
        
        // Determine best fit dimensions while maintaining aspect ratio
        if (naturalWidth && naturalHeight) {
          if (aspectRatio > 1) {
            // Wider than tall - constrain by width
            if (naturalWidth > container.offsetWidth) {
              img.style.width = '100%';
              img.style.height = 'auto';
            } else {
              img.style.width = 'auto';
              img.style.height = 'auto';
            }
          } else {
            // Taller than wide - constrain by height
            if (naturalHeight > 400) {
              img.style.height = '400px';
              img.style.width = 'auto';
            } else {
              img.style.width = 'auto';
              img.style.height = 'auto';
            }
          }
        }
        
        // Add permanent marker to protect the image
        img.setAttribute('data-permanent-image', 'true');
        
        // Force a redraw to ensure dimensions are applied
        img.style.opacity = '0.99';
        setTimeout(function() {
          img.style.opacity = '1';
        }, 10);
      }
      
      // Check if the image is already preloaded
      const preloadedImage = document.querySelector('#product-image-preload img[src="' + imageUrl + '"]');
      const isPreloaded = preloadedImage !== null;
      
      // Update main image - multiple approaches for redundancy
      if (currentMainImages.length > 0) {
        // Update all images with direct src update (faster for preloaded images)
        currentMainImages.forEach(function(img) {
          // If the image is preloaded, just set the src directly (very fast)
          if (isPreloaded) {
            img.src = imageUrl;
            normalizeImageSizing(img);
          } else {
            // Force image reload by adding a cache-busting parameter for non-preloaded images
            var updatedUrl = imageUrl + (imageUrl.includes('?') ? '&' : '?') + '_t=' + new Date().getTime();
            
            // Create a new image to preload
            var preloadImg = new Image();
            preloadImg.onload = function() {
              // Update the real image source after preloading
              img.src = updatedUrl;
              
              // Apply normalization immediately
              normalizeImageSizing(img);
            };
            preloadImg.src = updatedUrl;
          }
          
          // Update other attributes
          if (img.hasAttribute('data-src')) {
            img.setAttribute('data-src', imageUrl);
          }
          
          // Remove srcset to prevent responsive image issues
          if (img.hasAttribute('srcset')) {
            img.removeAttribute('srcset');
          }
          
          // Immediately apply baseline styling
          normalizeImageSizing(img);
        });
        
        // Handle zoom containers
        document.querySelectorAll('.js-zoom-img, .zoom-image').forEach(function(zoomContainer) {
          zoomContainer.setAttribute('data-zoom-image', imageUrl);
          
          // Ensure consistent container dimensions
          zoomContainer.style.height = '400px';
          zoomContainer.style.minHeight = '400px';
          zoomContainer.style.maxHeight = '400px';
          zoomContainer.style.display = 'flex';
          zoomContainer.style.alignItems = 'center';
          zoomContainer.style.justifyContent = 'center';
        });
        
        // Final normalization after a delay (to catch any rendering issues)
        setTimeout(function() {
          document.querySelectorAll(mainImageSelector + ' img').forEach(normalizeImageSizing);
        }, 50);
      } else {
        console.warn('No main images found for selector:', mainImageSelector);
      }
    }
    
    // Navigation for thumbnails
    if (prevButton && nextButton) {
      // Remove any existing event listeners
      var newPrevButton = prevButton.cloneNode(true);
      var newNextButton = nextButton.cloneNode(true);
      prevButton.parentNode.replaceChild(newPrevButton, prevButton);
      nextButton.parentNode.replaceChild(newNextButton, nextButton);
      
      // Get fresh references
      prevButton = newPrevButton;
      nextButton = newNextButton;
      
      // Make sure arrows are visible - supply fallback HTML entities if needed
      if (prevButton.innerHTML.trim() === '') {
        if (isVertical) {
          prevButton.innerHTML = '&#9650;'; // Up arrow
          nextButton.innerHTML = '&#9660;'; // Down arrow
        } else {
          prevButton.innerHTML = '&#9664;'; // Left arrow
          nextButton.innerHTML = '&#9654;'; // Right arrow
        }
      }
      
      // Add event listeners
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        navigateThumbnails(-1);
      });
      
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        navigateThumbnails(1);
      });
      
      // Initialize button state
      updateButtonState();
    }
    
    // Add touch swipe support for mobile devices
    thumbnailsContainer.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    
    thumbnailsContainer.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    }, { passive: true });
    
    function handleSwipe() {
      // Calculate distances
      var distanceX = touchEndX - touchStartX;
      var distanceY = touchEndY - touchStartY;
      var absDistanceX = Math.abs(distanceX);
      var absDistanceY = Math.abs(distanceY);
      
      // Only handle the swipe if it exceeds the minimum threshold
      if (isVertical && absDistanceY > minSwipeDistance) {
        // For vertical thumbnails, handle vertical swipes
        if (distanceY > 0) {
          // Swiped down, go to previous
          navigateThumbnails(-1);
        } else {
          // Swiped up, go to next
          navigateThumbnails(1);
        }
      } else if (!isVertical && absDistanceX > minSwipeDistance) {
        // For horizontal thumbnails, handle horizontal swipes
        if (distanceX > 0) {
          // Swiped right, go to previous
          navigateThumbnails(-1);
        } else {
          // Swiped left, go to next
          navigateThumbnails(1);
        }
      }
    }
    
    // Apply initial styles to thumbnail wrapper
    if (thumbnailWrapper) {
      if (isVertical) {
        thumbnailWrapper.style.display = 'flex';
        thumbnailWrapper.style.flexDirection = 'column';
        thumbnailWrapper.style.gap = '5px';
        thumbnailWrapper.style.transition = 'transform 0.3s ease';
      } else {
        thumbnailWrapper.style.display = 'flex';
        thumbnailWrapper.style.flexDirection = 'row';
        thumbnailWrapper.style.gap = '5px';
        thumbnailWrapper.style.transition = 'transform 0.3s ease';
      }
    }
  });
} 